export default "__VITE_ASSET__ea1e8f26__"